import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import PunchService from 'services/PunchService'

const PunchEndBreakModal = ({ punchCard, currentlyPunchedBreak }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector(state => state.users)

  const [isSubmitting, setIsSubmitting] = useState()

  const confirmPunch = async () => {
    setIsSubmitting(true)
    PunchService.endBreak(punchCard._id, currentlyPunchedBreak, userInfo)
    dispatch(closeModal())
  }

  return (
    <BaseModal hideButtons title={`employee.punch.BREAK_END_MODAL`}>
      <div className="mt-2">
        <Button text="actions.CONFIRM" isSubmitting={isSubmitting} className="btn btn-primary mr-2" onClick={() => confirmPunch()} />
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default PunchEndBreakModal
